<template>
  <DataTable :value="products" class="primevue-dtable tablepaginator p-datatable-customers rwd-table my-4"
    v-if="loading">
    <Column v-for="col in columns" :header="col.header">
      <template #body>
        <Skeleton></Skeleton>
      </template>
    </Column>
  </DataTable>
</template>

<script lang="ts">
import { ref, defineComponent, PropType } from 'vue';
export default defineComponent({
  props: {
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    // let products = ref([10]);
    const products = ref(new Array(10));
    return {
      products
    }
  }
})

</script>
